<template>
    <div class="tab-general-info">
        <div class="smalltitle blockcont">General Information</div>
        <div class="blockcont">
            <form>
                <div class="prolabel">First Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.firstName" maxlength="100"
                           :disabled="disabledForm">
                </div>
                <div class="prolabel">Last Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.lastName" maxlength="100"
                           :disabled="disabledForm"></div>
                <div class="prolabel">
                    Title Suffix
                    <span style="color: #d9df20;"
                          title="This will show on your social network profile and as a suffix after your name in the EMR and on prescription."
                          class="light">(?)</span>
                </div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.title" maxlength="30" :disabled="disabledForm"
                           placeholder="Please type your credentials: MD, DO, MD PhD…">
                </div>

                <div class="prolabel">Day of Birth</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedDay" :disabled="disabledForm">
                                <option :value="generalInfo.selectedDay"> {{generalInfo.selectedDay}}</option>
                            </select>
                        </div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedMonth" :disabled="disabledForm">
                                <option :value="generalInfo.selectedMonth"> {{generalInfo.selectedMonth}}</option>
                            </select></div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedYear" :disabled="disabledForm">
                                <option :value="generalInfo.selectedYear"> {{generalInfo.selectedYear}}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="prolabel">Home Address</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-12">
                            <input type="text" :disabled="disabledForm"
                                   v-model="generalInfo.home_address_streetName"
                                   maxlength="255">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4">
                            <input  type="text" :disabled="disabledForm"
                                   v-model="generalInfo.home_address_city" maxlength="100"/>
                        </div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.home_address_state" :disabled="disabledForm">
                                <option :value="state.code"
                                        v-for="state in US_STATES">{{state.name}}</option>
                            </select>
                        </div>
                        <div class="col-xs-4">
                            <input type="text"  :disabled="disabledForm"
                                                     v-model="generalInfo.home_address_zipCode" maxlength="10">
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="prolabel">Biography</div>
                <div class="profield">

                    <div v-html="generalInfo.biography"
                         style="height: 244px; resize: both; overflow: auto; border: 1px solid rgb(225, 225, 225);"
                         id="biography"
                         class="formattext"></div>
                </div>
                <div class="prolabel">Website</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.website"
                           :disabled="disabledForm">
                </div>
                <div class="prolabel">NPI</div>
                <div class="profield"><input type="text" v-model="generalInfo.NPI" disabled="disabled"  :disabled="disabledForm"></div>
                <div class="prolabel">Taxonomy Code
                    <span style="color: #d9df20;"
                          title="The taxonomy entered here will be used at the EMR to imported into BOX 19 of the CMS1500 claim form. The choice of clinic or physician taxonomy depends on each insurance."
                          class="light">(?)</span>
                </div>
                <div class="profield">
                    <div id="taxonomy_code" v-for="(taxonomy_code) in generalInfo.taxonomy_code">
                        <input disabled="disabled" style="width: 49%" type="text" v-model="taxonomy_code.code" placeholder="Code"  :disabled="disabledForm">
                        <input disabled="disabled" style="width: 49%" type="text" v-model="taxonomy_code.description"  :disabled="disabledForm"
                               placeholder="Description">
                    </div>
                </div>

                <div class="prolabel">Clinical Expertise</div>
                <div class="profield">
                    <textarea v-model="generalInfo.clinicExpertise" rows="8"  :disabled="disabledForm"></textarea>
                </div>
                <div class="prolabel">Research Interests</div>
                <div class="profield"><textarea v-model="generalInfo.researchInterest"  :disabled="disabledForm"
                                                style="height: 250px"></textarea></div>

            </form>
        </div>
    </div>
</template>

<script>
import config from '../../../../config'
import httpClient from '../../../../client'
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import StateConfig from '../../../../config/state'
export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    userInfo: {},
    disabledForm: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      US_STATES: StateConfig.US_STATES,
      generalInfo: {}
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    this.getGeneral()
  },
  beforeDestroy () {
  },
  methods: {
    async getGeneral () {
      try {
        let response = await httpClient.get('/users/general/' + this.userInfo.id)
        if (response.data.s === 200) {
          let general = response.data.data.general
          if (general) {
            this.generalInfo = general
            if (this.generalInfo.taxonomy_code) {
              this.generalInfo.taxonomy_code = JSON.parse(this.generalInfo.taxonomy_code)
            }
            if (this.userInfo) {
              this.generalInfo.firstName = this.userInfo.firstName
              this.generalInfo.lastName = this.userInfo.lastName
              this.generalInfo.title = this.userInfo.title
            }
            if (this.generalInfo.birthday) {
              let date = this.generalInfo.birthday.split('-')
              this.generalInfo.selectedDay = date[2]
              this.generalInfo.selectedMonth = date[1]
              this.generalInfo.selectedYear = date[0]
            }
            this.$forceUpdate()
          }
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
